'use strict';

var ValidColumnOrValueValidation = function ValidColumnOrValueValidation() {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function link(scope, ele, attrs, ctrl) {
      ctrl.$parsers.unshift(function (value) {
        var valid = true;
        if (value) {
          valid = scope.isValidColumnOrValue(value);
          ctrl.$setValidity('validColumnOrValue', valid);
        }
        return value;
      });
    }
  };
};
ValidColumnOrValueValidation.$inject = [];
module.exports = ValidColumnOrValueValidation;